import { render, staticRenderFns } from "./InsuranceOptions.vue?vue&type=template&id=60ad99b3&scoped=true"
import script from "./InsuranceOptions.vue?vue&type=script&lang=js"
export * from "./InsuranceOptions.vue?vue&type=script&lang=js"
import style0 from "./InsuranceOptions.vue?vue&type=style&index=0&id=60ad99b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ad99b3",
  null
  
)

export default component.exports